import React from 'react';
import { useField } from 'react-final-form';
import {
  FormControl, FormErrorMessage, FormHelperText, Select, useColorModeValue,
} from '@chakra-ui/react';
import FieldLabel from './FieldLabel';

interface SelectInputControlProps {
  name: string;
  label: string;
  isRequired?: boolean;
  disabled?: boolean;
  // item 254 — optional plain-language explainer under the control (legible in both skins)
  helperText?: string;
  children: any;
}
const SelectInputControl: React.FC<SelectInputControlProps> = ({
  name, label, isRequired, disabled, helperText, children,
}) => {
  const { input, error, touched } = useField(name, { type: 'select' });
  const helpColor = useColorModeValue('gray.600', 'whiteAlpha.700');
  return (
    <FormControl isInvalid={error && touched} isRequired={isRequired}>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      <Select
        {...input}
        isInvalid={error && touched}
        id={name}
        isDisabled={disabled}
      >
        <option value="">{label}</option>
        {children}
      </Select>
      {helperText && <FormHelperText color={helpColor}>{helperText}</FormHelperText>}
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
SelectInputControl.defaultProps = {
  isRequired: false,
  disabled: false,
  helperText: undefined,
};
export default SelectInputControl;
